import WsCheckBox from '../../../components/WsCheckBox/WsCheckBox';

import WsAccordion from './WsAccordion';

interface CheckboxFilterProps {
  name: string;
  title: string;
  label: string;
  disabled?: boolean;
  infoText?: string;
  startIcon?: React.ReactElement;
}

const CheckboxFilter = ({
  name,
  title,
  label,
  disabled,
  infoText,
  startIcon,
}: CheckboxFilterProps) => (
  <WsAccordion
    title={title}
    disabled={disabled}
    infoText={infoText}
    {...(startIcon && { startIcon: startIcon })}
  >
    <WsCheckBox name={name} label={label} />
  </WsAccordion>
);

export default CheckboxFilter;
